import React, { useEffect, useState } from "react";
import useAxios from "../../hooks/useAxios";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../Components/Loading";
import { alertWarning } from "../../Components/CustomAlerts/AlertToast";
import { WeeklyReportForm } from "../../Components/WeeklyReports/WeeklyReportForm";

const CreateWeeklyReport = () => {
  const { get } = useAxios();
  const navigate = useNavigate();
  const [weeks, setWeeks] = useState([]);
  const [months, setMonths] = useState([]);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    setFetching(true);
    const getWeekReportData = async () => {
      try {
        const response = await get(`weekly_reports/create`);
        setWeeks(response.data.Weeks);
        setMonths(response.data.Months);
      } catch (error) {
        alertWarning(
          "Sorry. You are not authorised to create weekly report!",
          null,
          5000
        );
      } finally {
        setFetching(false);
      }
    };
    getWeekReportData();
  }, []);

  return (
    <>
      {fetching ? (
        <Loading />
      ) : (
        <Card className="container">
          <Card.Header className="d-flex justify-content-between mt-0 mb-5">
            <Card.Title>
              <div className="row">
                <div className="col-md-12">
                  <h1 className="page-title">Create Weekly Report</h1>
                </div>
              </div>
            </Card.Title>

            <div className="row">
              <div className="col-md-12">
                <Button onClick={() => navigate(-1)}>Back</Button>
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <WeeklyReportForm months={months} weeks={weeks} />
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default CreateWeeklyReport;
